export default __webpack_public_path__ + "models/30742c58b00f9472826a333b19750e76.glb";